/**
 * The aotdrace-2.1 no-emoji penalty, as the SPA sees it. Mirrors
 * n450s_backend `modules/aotd/services/noEmojiPenalty.ts`.
 *
 * A racer with no next-AOTD emojis staged, who already authored an AOTD with
 * none, gets +450ms on their race time. It hits once: racing again the next
 * day waives it, skipping a day brings it back. On a race row it shows up as
 * an `appliedEffects[]` entry with `cardSlug: "no-emoji-penalty"`: deltaMs 450
 * when charged, 0 when waived.
 */

export const NO_EMOJI_PENALTY_SLUG = "no-emoji-penalty";

interface EffectLike {
  cardSlug?: string | null;
  deltaMs?: number | null;
}

export function isNoEmojiPenaltyEffect(effect: EffectLike | null | undefined): boolean {
  return effect?.cardSlug === NO_EMOJI_PENALTY_SLUG;
}

/** The penalty actually charged on a row (0 when waived or absent). */
export function noEmojiPenaltyMsOf(effects: EffectLike[] | null | undefined): number {
  if (!Array.isArray(effects)) return 0;
  return effects
    .filter(isNoEmojiPenaltyEffect)
    .reduce((sum, e) => sum + (typeof e.deltaMs === "number" ? e.deltaMs : 0), 0);
}

/** Card effects only (the penalty and its waived marker filtered out). */
export function cardEffectsOf<T extends EffectLike>(effects: T[] | null | undefined): T[] {
  return Array.isArray(effects) ? effects.filter((e) => !isNoEmojiPenaltyEffect(e)) : [];
}
